import { Box, Flex, ListItem, OrderedList, Text } from "@chakra-ui/react";
import type { SlideComoUtilizar } from "@/components/consignado/Cobranca/VinculosAtivosRedesign/ComoUtilizarModal";
import { fieldFont } from "./styleTokens";

/**
 * Slide "Teste do template" do Como utilizar — o fluxo do botão "Testar
 * template" e da TesteDisparoModal. Mudando o fluxo lá (o que é salvo, o que o
 * Confirmar faz), mudar aqui também.
 */
const PASSOS: { titulo: string; texto: string }[] = [
  {
    titulo: "Clique em Testar template.",
    texto:
      "O disparo é salvo inativo e a janela de teste abre. Um disparo que já estava ativo fica pausado durante o teste.",
  },
  {
    titulo: "Informe para onde enviar.",
    texto:
      "Um campo por canal: e-mail, celular do SMS ou número do WhatsApp. No telefone, só DDD + número — o 55 do Brasil entra sozinho. O último destino usado fica lembrado.",
  },
  {
    titulo: "Envie o teste.",
    texto:
      "A mensagem vai só para esse destino, com valores de exemplo nas variáveis, já no formato escolhido. O teste não entra no histórico de envios e pode ser repetido quantas vezes precisar.",
  },
  {
    titulo: "Confira e decida.",
    texto:
      "Chegou como esperado: Confirmar volta para a lista e ativa o disparo se \"Ativo\" estiver ligado na identificação. Algo errado: Editar template devolve ao formulário; Enviar de novo repete o envio.",
  },
];

function TesteTemplate() {
  return (
    <Box {...fieldFont}>
      <Text fontSize="sm" color="gray.600" mb={3} {...fieldFont}>
        O <strong>Testar template</strong>, ao lado do Salvar, manda a mensagem do disparo para você
        conferir antes de ela chegar a alguém do público.
      </Text>
      <OrderedList spacing={3} ml={5} mb={4}>
        {PASSOS.map((p) => (
          <ListItem key={p.titulo} fontSize="sm" color="gray.700" {...fieldFont}>
            <Text as="span" fontWeight="600" color="gray.800">
              {p.titulo}
            </Text>{" "}
            {p.texto}
          </ListItem>
        ))}
      </OrderedList>
      <Flex direction="column" gap={2} bg="gray.50" borderRadius="md" p={3}>
        <Text fontSize="xs" color="gray.700" {...fieldFont}>
          <strong>Por que o teste salva inativo?</strong> Um disparo ativo entra na agenda na hora: a
          rotina roda para o público no próximo horário, antes mesmo de você ver o teste. Inativo,
          nada sai para o público até você confirmar.
        </Text>
        <Text fontSize="xs" color="gray.700" {...fieldFont}>
          O <strong>Salvar</strong> continua gravando como está na identificação — com
          &quot;Ativo&quot; ligado, o disparo já sai ativo, sem teste.
        </Text>
        <Text fontSize="xs" color="gray.700" {...fieldFont}>
          Se a janela disser que o ambiente ainda não tem o envio de teste, nada foi enviado: aquele
          ambiente ainda não recebeu essa função.
        </Text>
      </Flex>
    </Box>
  );
}

export const SLIDE_TESTE_TEMPLATE: SlideComoUtilizar = {
  titulo: "Teste do template",
  conteudo: <TesteTemplate />,
};
